import { Observable } from 'rxjs/Observable';
import { HttpError } from './http-error';

export class HttpResponse<T> {
    httpVersion: string;
    responseCode: string;
    headers: { key: string; value: string }[];
    body: T;
    error: HttpError;
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/shared/http-response.ts